import { Form } from '@mairistem/composants';
import { Panel } from '@mairistem/finances-utils';
import React from 'react';
import PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const NumeroEmpruntComponent = ({
  data,
  handlePin,
  onChange,
  panel,
}: PanelComponentProps) => {
  const handleChange = (e, { name, value }) => onChange?.({ [name]: value }, panel);

  return (
    <Panel panel={panel} onPin={handlePin}>
      <Form>
        <Form.Input
          name="emprunt"
          key="emprunt"
          value={data?.emprunt ?? ''}
          title={data?.emprunt ?? ''}
          label="‎"
          fluid
          maxLength={24}
          onChange={handleChange}
          data-testid="numeroEmpruntInput"
        />
      </Form>
    </Panel>
  );
};

export default NumeroEmpruntComponent;
